/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const investmentRiskSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "investmentRisk",

  //STATE PROPERTIES INCLUDED IN THIS SLICE
  initialState: {
    //INVESTMENT - RISK
    riskObjective: "1",
    riskTimeObjective: "",
    riskReturnsObjective: "",
    riskToleranceObjective: "",
    riskResponseObjective: "",
    riskRangeObjective: "",
    riskScore: "",
    riskType: "",
    riskDesc: "",

    //CKA_CKR - EDUCATION
    isEducationQualified: "",
    eduFields: "",
    educationInstitute: "",

    //CKA_CKR - QUALIFICATION
    isFinanceQualified: "",
    financeEducationInstitute: "",

    //CKA_CKR - INVESTMENT EXPERIENCE
    isExperiencedInvestor: "",
    investedProducts: "",
    investmentInstitute: "",

    //CKA_CKR - WORK EXPERIENCE
    isWorkExperienced: "",
    experienceType: "",
    workOrganisationName: "",
  },

  //REDUCERS INSIDE EACH SLICE DECLARATION CAN PERFORM ACTION ON EACH DATA STATES
  reducers: {
    updateRisk: (state, action) => {
      let data = action.payload.payload;
      state.riskObjective = data.riskObjective;
      state.riskTimeObjective = data.riskTimeObjective;
      state.riskReturnsObjective = data.riskReturnsObjective;
      state.riskToleranceObjective = data.riskToleranceObjective;
      state.riskResponseObjective = data.riskResponseObjective;
      state.riskRangeObjective = data.riskRangeObjective;
      state.riskScore = data.riskScore;
      state.riskType = data.riskType;
      state.riskDesc = data.riskDesc;
    },

    updateCKACKR: (state, action) => {},
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateRisk } = investmentRiskSlice.actions;

export default investmentRiskSlice.reducer;
